function updateDigitalWalletsOptions(results) {
  const $ = jQuery;
  // console.log('updateDigitalWalletsOptions results', results);

  // Convert dollars to cents for Olo Pay amounts
  const toCents = (val) => Math.round(parseFloat(val) * 100);

  digitalWalletsOptions = {
    options: {
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Pay East Coast Wings',
        amount: toCents(results.total),
      },
      displayItems: [
        { label: 'Subtotal', amount: toCents(results.subtotal) },
        ...(results.discounts || []).map((discount) => ({
          label: discount.description || 'Discount',
          amount: -toCents(discount.amount),
        })),
        ...(results.fees || []).map((fee) => ({
          label: fee.label || 'Fee',
          amount: toCents(fee.amount),
        })),
        ...(results.taxes || []).map((tax) => ({
          label: tax.label || 'Tax',
          amount: toCents(tax.tax),
        })),
        results.tip ? { label: 'Tip', amount: toCents(results.tip) } : null,
      ].filter(Boolean),
      requestPayerName: true,
    },
    style: {
      type: 'default',
      theme: 'dark',
      height: '48px',
    },
  };
}
// Returns the id for a given service ("GooglePay" or "ApplePay"), or null
function getBillingSchemeId(schemes, serviceName) {
  // Debugging info (remove in production)
  console.log('getBillingSchemeId input:', schemes, serviceName);

  // If schemes is a JSON string attempt to parse it
  if (typeof schemes === 'string') {
    try {
      schemes = JSON.parse(schemes);
    } catch (err) {
      // console.warn('getBillingSchemeId: schemes is not valid JSON');
      return null;
    }
  }

  // If caller passed an object with a .billingschemes array, unwrap it
  if (schemes && !Array.isArray(schemes) && Array.isArray(schemes.billingschemes)) {
    schemes = schemes.billingschemes;
  }

  if (!Array.isArray(schemes)) {
    // console.warn('getBillingSchemeId: schemes is not an array');
    return null;
  }

  // Normalizer: remove spaces/hyphens and lowercase
  var normalize = function (v) {
    return ('' + v).replace(/[\s\-–—]/g, '').toLowerCase();
  };
  var target = normalize(serviceName);

  for (var i = 0; i < schemes.length; i++) {
    var item = schemes[i];
    var settings = item && item.billingsettings;
    if (!Array.isArray(settings)) continue;

    for (var j = 0; j < settings.length; j++) {
      var s = settings[j];
      if (!s || !s.name || !s.value) continue;

      if (s.name.toLowerCase() === 'service' && normalize(s.value) === target) {
        return item.id != null ? item.id : null;
      }
    }
  }

  // nothing matched
  return null;
}

function loadInDigitalWallets(billing_schemes) {
  const $ = jQuery;

  function callback(paymentMethod) {

    if (paymentMethod) {
      if (localStorage.getItem('ecw_access_token') && localStorage.getItem('ecw_auth_token')) {
        userType = 'user'
      } else {
        userType = 'guest'
      }
      const paymentMethodType = paymentMethod.card.wallet.type;
      console.log('billingschemesid', billing_schemes);
      if (paymentMethodType === 'google_pay') {
        thisbillingschemesid = getBillingSchemeId(billing_schemes, 'Google Pay');
      } else if (paymentMethodType === 'apple_pay') {
        thisbillingschemesid = getBillingSchemeId(billing_schemes, 'Apple Pay');
      }
      console.log('thisbillingschemesid', thisbillingschemesid, paymentMethodType);

      let requestData = {
        action: "olo_submit_digital_wallet_payment",
        token: paymentMethod.id,
        cardType: paymentMethod.card.brand,
        cardLastFour: paymentMethod.card.last4,
        expiryyear: paymentMethod.card.exp_year,
        expirymonth: paymentMethod.card.exp_month,
        zip: paymentMethod.card.checks.address_postal_code_check,
        billingschemeid: thisbillingschemesid,
        basketGuid: localStorage.getItem('ecw_customer_basket_id'),
        userType: userType,
        referer: window.location.href,
      };

      console.log('requestData', requestData);

      // Conditionally add user or guest data
      if (userType === 'user') {
        requestData.authtoken = localStorage.getItem('ecw_auth_token');
        // Do not send guest info
      } else { // userType is 'guest'
        requestData.firstname = localStorage.getItem('ecw_customer_guest_first_name');
        requestData.lastname = localStorage.getItem('ecw_customer_guest_last_name');
        requestData.emailaddress = localStorage.getItem('ecw_customer_guest_email');
        requestData.contactnumber = localStorage.getItem('ecw_customer_guest_phone_number');
        // Do not send auth token
      }
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: requestData,
      })
        .done(function (response) {
          ecw_show_loading();
          try {
            var results = JSON.parse(response);
            console.log('Success!', results); // Log the successful response
            if (results.code && results.code !== 0 && results.code === 200) {
            } else if (results.code && results.code !== 0 && (results.code !== 201)) {
              digitalWallets.failPaymentEvent();
              console.log('i fail!');
              alert("Something went wrong submitting your payment. Please try again.");
            } else {
              digitalWallets.completePaymentEvent();
              // Get Order
              // console.log('olo_get_order');
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_get_order",
                  orderguid: results.id,
                  referer: window.location.href

                },
                success: function (response) {
                  var order_data = JSON.parse(response);

                  // Send GA4/GTM Ecomm Data
                  var gtmDLProducts = [];
                  var ga4DLProducts = [];

                  // Set Analytics product data
                  for (var i = 0; i < order_data.products.length; i++) {
                    gtmDLProducts.push({
                      "name": order_data.products[i].name,
                      "sku": order_data.products[i].id,
                      "price": order_data.products[i].totalcost,
                      "quantity": order_data.products[i].quantity,
                      // 'category': result.products[i]
                    });
                    ga4DLProducts.push({
                      "item_id": order_data.products[i].id,
                      "item_name": order_data.products[i].name,
                      "price": order_data.products[i].totalcost,
                      "quantity": order_data.products[i].quantity,
                      "affiliation": results.vendorname
                      // "item_category": localStorage.getItem('lumos_orderstate')
                    });
                  }

                  // Set User Type
                  var orderUserType = "Guest";
                  if (localStorage.getItem("ecw_auth_token")) {
                    orderUserType = "Member";
                  }

                  // Set Taxes
                  var orderTaxes = 0;
                  for (var ii = 0; order_data.taxes.length > ii; ii++) {
                    orderTaxes += order_data.taxes[ii].tax;
                  }

                  // Set Order Fees
                  var orderFees = 0;
                  for (var iii = 0; order_data.fees.length > iii; iii++) {
                    orderFees += order_data.fees[iii].amount;
                  }
                  if (order_data.customerhandoffcharge) {
                    orderFees += order_data.customerhandoffcharge;
                  }

                  // Set Order Coupon
                  var orderCoupon = "";
                  for (var iv = 0; order_data.discounts.length > iv; iv++) {
                    if (order_data.discounts[iv].type == "Coupon") {
                      orderCoupon = order_data.discounts[iv].description;
                      break;
                    }
                  }

                  var gtmDL = {
                    "event": "purchase", // Residential - eCommerce - Order Captured
                    "transactionId": order_data.oloid,
                    "transactionTotal": order_data.total,
                    "transactionTax": orderTaxes,
                    "transactionProducts": gtmDLProducts,
                    "shipping": orderFees,
                    "transactionShipping": orderFees,
                    "affiliation": order_data.vendorname,
                    "transactionAffiliation": order_data.vendorname,
                    "coupon": orderCoupon,
                    "userType": orderUserType,
                    "orderType": order_data.deliverymode,
                  };

                  var ga4CustomerEmail = localStorage.getItem("ecw_customer_guest_email");
                  var ga4PhoneNumber = localStorage.getItem("ecw_customer_guest_phone_number");
                  var ga4UserID = localStorage.getItem("ecw_user_id");

                  // if (user_details_json && user_contact_details_json) {
                  //   var user_details = JSON.parse(user_details_json[0]);
                  //   var user_contact_details = JSON.parse(user_contact_details_json[0]);

                  //   ga4CustomerEmail = user_details.emailaddress;
                  //   ga4PhoneNumber = user_contact_details.contactdetails;
                  // }

                  var ga4DL = {
                    "event": "purchase",
                    'ecommerce': {
                      "transaction_id": results.oloid,
                      "affiliation": results.vendorname,
                      "value": results.total,
                      "tax": orderTaxes,
                      "currency": "USD",
                      "coupon": orderCoupon,
                      "userType": orderUserType,
                      "orderType": results.deliverymode,
                      "shipping": orderFees,
                      "items": ga4DLProducts
                    },
                    "user_data": {
                      "user_id": ga4UserID,
                      "email_address": ga4CustomerEmail,
                      "phone_number": ga4PhoneNumber
                    }
                  };

                  // console.log("GTMDL: ", gtmDL);
                  // console.log('GA4DL:', ga4DL);
                  const hasExtraCookieConsent = checkNonNecessaryConsent();
                  if (hasExtraCookieConsent) {
                    // Push Legacy DataLayer GTM
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(ga4DL);
                  }



                  // var ga4Data = {
                  //   'event': "purchase",
                  //   'ecommerce': ga4DL
                  // };
                  // console.log('GA4:', ga4Data);

                  // Push into GA4
                  // gtag('event', 'purchase', ga4DL);

                  // window.dataLayer.push({ ecommerce: null });
                  // window.dataLayer.push(ga4Data);

                  // Clear cart session
                  clearBasketSession();
                  localStorage.setItem(
                    "ecw_customer_order",
                    JSON.stringify(results)
                  );
                  //
                  view_order_complete(results);
                  history.pushState(null, '', '/order/#order-complete');

                  // change_view("order-complete");
                  ecw_hide_loading();

                },
              });
            }
          } catch (e) {
            // This catches the JSON.parse error.
            digitalWallets.failPaymentEvent();
            console.error('Failed to parse JSON response:', e);
            alert("Something went wrong with the order. Please try again.");
          }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
          // This handles AJAX network errors.
          digitalWallets.failPaymentEvent();
          console.log('i fail');
          alert("Something went wrong submitting your payment. Please try again.");
        })
        .always(function () {
          // This runs regardless of success or failure.
          ecw_hide_loading();
        });


    }
  }

  // console.log('digitalWalletsOptions', digitalWalletsOptions);
  digitalWallets.initialize(digitalWalletsOptions)
    .then(() => {
      const canPay = digitalWallets.canMakePayment;
      // console.log('canPay', canPay);
      // console.log('digitalWallets', digitalWallets);

      if (canPay && (canPay.googlePay || canPay.applePay)) {
        digitalWallets.mountButton(callback);
      } else {
        // console.log('i hide');
        $('[data-olo-pay-payment-button]').hide();
        $('[data-olo-pay]').hide();
      }
    })
    .catch((error) => {
      console.error('Failed to initialize Digital Wallets:', error);
      $('[data-olo-pay]').addClass('hide');

    });

}


var validateCheckoutBasketDeferred = jQuery.Deferred();
function validateCheckoutBasket(deferred, validBasket) {
  var $ = jQuery;

  if ('code' in validBasket) {
    if (validBasket.num == 206 || validBasket.num == 218) {
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "olo_get_basket",
          basketGuid: localStorage.getItem("ecw_customer_basket_id"),
          referer: window.location.href,

        },
        success: function (response) {
          var result = JSON.parse(response);
          // console.log('validateCheckoutBasket', result);

          if (result.timewanted == null || result.timewanted == '') {
            var earliestreadytime = result.earliestreadytime;

            var apiData = {
              action: 'olo_set_timewanted',
              basketGuid: localStorage.getItem('ecw_customer_basket_id'),
              referer: window.location.href,
            };

            let earliestReadyYear = earliestreadytime.substr(0, 4);
            let earliestReadyMonth = earliestreadytime.substr(4, 2);
            let earliestReadyDay = earliestreadytime.substr(6, 2);
            let earliestReadyHour = earliestreadytime.substr(9, 2);
            let earliestReadyMinute = earliestreadytime.substr(12, 2);

            // add buffer to earliestreadytime to account for checkout time
            earliestReadyMinute = Number(earliestReadyMinute) + 5;
            if (earliestReadyMinute > 59) {
              earliestReadyMinute = earliestReadyMinute - 60;
              earliestReadyHour = Number(earliestReadyHour) + 1;
            }
            if (earliestReadyHour > 23) {
              earliestReadyHour = earliestReadyHour - 24;
              earliestReadyDay = Number(earliestReadyDay) + 1;
            }

            // prevent asap rollover
            let currentDateJs = new Date();
            if (earliestreadytime.substr(6, 2) != currentDateJs.getDate() && localStorage.getItem('ecw_original_customer_schedule') == 'asap') {
              setCheckoutError('This ASAP order will not be ready until after this location closes.');
              // console.log('asgadsgdsgsadgasdgasdg');
              if ($('#order-is-next-day').length) {
                setCheckoutError('This ASAP order will not be ready until after this location closes.');
                $(document).foundation();
                $('#order-is-next-day').foundation('open');
                if (result.earliestreadytime) {
                  let rawDateTime = result.earliestreadytime;

                  // Split date and time
                  let datePart = rawDateTime.split(' ')[0];
                  let timePart = rawDateTime.split(' ')[1];

                  // Extract parts
                  let year = datePart.substring(0, 4);
                  let month = datePart.substring(4, 6);
                  let day = datePart.substring(6, 8);

                  // Create a new Date object
                  let formattedDate = new Date(year, month - 1, day); // month is 0-indexed

                  // Format nicely WITHOUT year
                  let options = { month: 'long', day: 'numeric' };
                  let formattedDateString = formattedDate.toLocaleDateString('en-US', options);

                  // Optional: convert to 12-hour time
                  let timeParts = timePart.split(':');
                  let hours = parseInt(timeParts[0]);
                  let minutes = timePart.split(':')[1];

                  let period = hours >= 12 ? 'PM' : 'AM';
                  hours = hours % 12;
                  hours = hours ? hours : 12; // the hour '0' should be '12'

                  let formattedTime = `${hours}:${minutes} ${period}`;

                  let finalOutput = `${formattedDateString} at ${formattedTime}`;

                  // console.log(finalOutput);
                  $('#order-is-next-day span[data-ready-date]').text(finalOutput);
                }



              } else {
                clearCheckoutError()
              }
              return deferred.resolve();
            } else {

              //

              apiData.timewanted = {
                ismanualfire: false,
                year: earliestReadyYear,
                month: earliestReadyMonth,
                day: earliestReadyDay,
                hour: earliestReadyHour,
                minute: earliestReadyMinute
              };

              return $.ajax({
                type: "POST",
                url: ajax_url,
                data: apiData,
                success: function (response) {
                  localStorage.setItem('ecw_customer_schedule', 'advance');
                  localStorage.setItem('ecw_customer_scheduled_day', earliestreadytime.substr(0, 4) + '-' + earliestreadytime.substr(4, 2) + '-' + earliestreadytime.substr(6, 2));
                  localStorage.setItem('ecw_customer_scheduled_time', earliestreadytime.substr(9, 2) + ':' + earliestreadytime.substr(12, 2));

                  localStorage.setItem('ecw_override_can_checkout', 'true');
                  clearCheckoutError();
                  // console.log('olo_validate_basket called');
                  // Revalidate
                  return $.ajax({
                    type: 'POST',
                    url: ajax_url,
                    data: {
                      action: 'olo_validate_basket',
                      basketGuid: localStorage.getItem('ecw_customer_basket_id'),
                      referer: window.location.href,

                    },
                    success: function (response) {
                      // console.log(response);
                      // console.log(JSON.parse(response));
                      //
                      // var results = JSON.parse(response);

                      // console.log('validate basket', response);
                    },
                    complete: function () {
                      return deferred.resolve();
                    }
                  });

                },
                complete: function () { },
              });
            }
          }
        }
      });
    } else {
      console.log('error', validBasket.message)
      setCheckoutError(validBasket.message);
      return deferred.resolve();
    }
  } else {
    clearCheckoutError();
    return deferred.resolve();
  }

  return deferred.promise();
}

// View: Checkout
function view_checkout() {
  var $ = jQuery;

  ecw_hide_topnav();
  ecw_show_loading();

  // Remove reveal modals
  // console.log('CC Reveals Count Before: ', $('.credit-card-reveal, .checkout-edit-store-location, .checkout-edit-order-type').length);
  $(
    ".credit-card-reveal, .checkout-edit-store-location, .checkout-edit-order-type"
  ).each(function () {
    if (typeof $(this).attr("aria-hidden") !== "undefined") {
      // console.log("removed: ", $(this).attr("id"));
      $(this).parent().remove();
    }
  });
  // console.log('CC Reveals Count After: ', $('.credit-card-reveal, .checkout-edit-store-location, .checkout-edit-order-type').length);

  if (canCheckout) {
    // First Validate Basket
    $.when(
      olo_validate_basket(),
      olo_get_ccsf_payment_token()
    ).done(function (
      validBasket_json,
      ccsf_payment_token_json
    ) {
      // console.log(validBasket_json);
      // console.log(ccsf_payment_token_json);

      var validBasket = JSON.parse(validBasket_json[0]);
      var ccsf_payment_token = JSON.parse(ccsf_payment_token_json[0]);

      if (
        ccsf_payment_token.accesstoken !==
        localStorage.getItem("ecw_customer_ccsf_token")
      ) {
        localStorage.setItem(
          "ecw_customer_ccsf_token",
          ccsf_payment_token.accesstoken
        );
      }

      $contentContainer.load(templateRoot + "wf-ordering-checkout.html", function () {
        $('.menu-page-callout').addClass('hide');
        //
        $(".edit-handoff").click(function () {
          ecw_show_loading();
          $(document).foundation();

          // console.log('i click'); 
          window.scrollTo(0, 0);
          // Close all open reveals before opening a new one
          // $('.reveal').foundation('close');
          $("#menu-select-order-type").foundation("open");

          loadInStoreEditInfo();
        });
        //
        $(".wf-ordering-checkout [data-add-another-menu-item]").click(function () {
          change_view("menu");

          getOrderTypeEditPopupInfo();
        });

        $backBtn = $(".wf-ordering-container [data-back-button]");
        $backBtn.click(function () {
          change_view('menu');

        });

        $.when(
          validateCheckoutBasket(validateCheckoutBasketDeferred, validBasket)
        ).done(function () {

          if ($('input[name="order-tip"]').length) {
            $('input[name="order-tip"]').change(function () {
              var tipValue = Number($('input[name="order-tip"]:checked').val());
              // console.log('tip amount', tipValue);
              $('#custom-tip-amount').val(formatMoney(tipValue));

              olo_set_tip_amount($('#custom-tip-amount').val());  
            });

            $('#custom-tip-amount').on('focus', function () {
              $('#tip-custom').prop('checked', true);
            });

            //setup before functions
            var typingTimer;                //timer identifier
            var doneTypingInterval = 1500;  //time in ms

            //on keyup, start the countdown
            $('#custom-tip-amount').keyup(function () {
              clearTimeout(typingTimer);
              if ($('#custom-tip-amount').val()) {
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
              }
            });

            //user is "finished typing," do something
            function doneTyping() {
              olo_set_tip_amount($('#custom-tip-amount').val());
            }
          }

          // Edit Contact Info
          if (isUserLoggedIn()) {
            // User is logged in
            $("[data-edit-contact-account]").removeClass("hide");
            $("[data-edit-contact-guest]").addClass("hide");
          } else {
            // Guest checkout
            $("[data-edit-contact-account]").addClass("hide");
            $("[data-edit-contact-guest]").removeClass("hide");
          }

          // Recreate reveal modals
          var $cc_reveal = new Foundation.Reveal($("#credit-card-reveal"), {});
          // var $editLocation = new Foundation.Reveal(
          //   $("#checkout-edit-store-location"),
          //   {}
          // );
          // var $editOrderType = new Foundation.Reveal(
          //   $("#checkout-edit-order-type"),
          //   {}
          // );

          // Set input mask for expiration date entry
          $('input#expiredate').inputmask({
            mask: dateMasks,
            greedy: false,
            inputmode: 'tel',
            definitions: { '#': { validator: "[0-9]", cardinality: 1 } }
          });

          // Prevent Credit Card Form from default submit
          $("#new-credit-card-form").submit(function (e) {
            e.preventDefault();
          });

          // Set up the CC payment form
          setCCFields();

          // Set CC form validation
          new Foundation.Abide($("#new-credit-card-form"), {
            validateOn: "fieldChange",
            validateOnBlur: true,
          });

          // Update form validation during form entry
          $("#new-credit-card-form input[required]").on(
            "change keyup blur",
            function () {
              $("#new-credit-card-form").foundation("validateForm");
            }
          );

          // Check validation status of form to enable/disable apply button
          $("#new-credit-card-form").on(
            "valid.zf.abide invalid.zf.abide",
            function (ev, el) {
              if ($('#new-credit-card-form [aria-invalid="true"]').length) {
                $("#credit-card-add-card").prop("disabled", true);
                $("#credit-card-update-card").prop("disabled", true);
              } else {
                $("#credit-card-add-card").prop("disabled", false);
                $("#credit-card-update-card").prop("disabled", false);
              }
            }
          );

          // Cancel Adding Card
          $("#credit-card-cancel").click(function () {
            setCCFields();
            $("#credit-card-reveal").foundation("close");
          });

          // Add Credit Card
          $("#credit-card-add-card").click(function () {
            var $savedSchemesContainer = $("[ data-billing-schemes-active]");
            var $savedScheme = $(
              "[data-billing-schemes-active-template].hide"
            ).clone();
            console.log('$savedScheme', $savedScheme);
            $savedScheme.attr("id", "new-card");
            $savedScheme.find("[data-payment-label]").text("Credit Card");

            $savedScheme
              .find("[data-apply-label]")
              .text("Amount To Apply for New Credit Card");

            $savedScheme.find("[data-edit]").click(function () {
              // Open CC Dialog
              $("#credit-card-reveal").foundation("open");
            });

            $savedScheme.find("[data-remove]").off("click");
            $savedScheme.find("[data-remove]").click(function () {
              console.log('remove');
              // Remove Dialog
              $('[data-open="credit-card-reveal"]').removeClass("hide");
              $("#new-card").remove();
              $("#credit-card-cancel").removeClass("hide");
              $(this).closest('.actions').find('[data-use]').text('USE').removeClass('applied');
              $(this).closest('.actions').find('[data-split]').text('USE').removeClass('applied');
              setCCFields();
              configPaymentOptions();
            });

            $savedScheme.find("input").attr("id", "new-card-input");
            $savedScheme.find("input").attr("name", "account-x-new-card");

            $savedScheme.find("input").inputmask({
              alias: "numeric",
              allowMinus: false,
              digits: 2,
              max: 9999.99,
            });

            $savedScheme.removeClass("hide");
            $savedSchemesContainer.append($savedScheme);

            $("#credit-card-add-card").addClass("hide");
            $("#credit-card-update-card").removeClass("hide");
            $("#credit-card-cancel").addClass("hide");

            $("#credit-card-reveal").foundation("close");
            $('[data-open="credit-card-reveal"]').addClass("hide");

            configPaymentOptions();
          });

          // Get and Display Store and Customer Info
          $.when(
            olo_get_restaurant(
              localStorage.getItem("ecw_customer_store_location_id")
            ),
            olo_get_user_details(),
            olo_get_user_contact_details(),
            olo_get_billing_schemes(),
            olo_get_rewards_schemes(),
            // olo_get_qualifying_rewards()
            // olo_get_applied_rewards(),
            olo_get_billing_accounts()
          ).done(function (
            restaurant_data_json,
            user_details_json,
            user_contact_details_json,
            billing_schemes_json,
            reward_schemes_json,
            // qualifiying_rewards_json
            // applied_rewards_json,
            user_billing_accounts_json
          ) {
            // console.log(restaurant_data_json, user_details_json, user_contact_details_json);
            // console.log('rewards: ', reward_schemes_json);
            // console.log('available rewards: ', qualifiying_rewards_json);

            // Display Restaurant Info
            var restaurant_data = JSON.parse(restaurant_data_json[0]);
            $("[data-menu-selected-store]").text(restaurant_data.name);
            $("[data-store-name]").text(restaurant_data.name);
            $("[data-store-address]").text(restaurant_data.streetaddress);
            $("[data-store-city]").text(
              restaurant_data.city +
              ", " +
              restaurant_data.state +
              " " +
              restaurant_data.zip
            );

            // if($('.wf-ordering-checkout [data-back-button]').length > 0){
            //   $defaultBackAction = false;
            //   $('.wf-ordering-checkout [data-back-button]').click(function () {
            //     change_view("menu");
            //     $('.wf-ordering-checkout .shopping-cart-view').foundation('open');
            //     $defaultBackAction = true;
            //   });
            // }

            // Display Delivery Mode
            const customerLSdeliverymode = localStorage.getItem('ecw_customer_deliverymode');

            if (customerLSdeliverymode) {
              $("[data-row-deliverymode]").text(customerLSdeliverymode.charAt(0).toUpperCase() + customerLSdeliverymode.slice(1));
            } else {
              // Optional: Handle the case where the value is null or not found.
              // For example, you could hide the element or set default text.
              $("[data-row-deliverymode]").hide();
            }

            if (customerLSdeliverymode == "dispatch") {
              $("[data-row-deliverymode]").text("Delivery");
            }

            let schedule = localStorage.getItem("ecw_customer_schedule");
            if (schedule && schedule.toLowerCase() === "asap") {
              schedule = "ASAP";
            }
            $("[data-row-schedule]").text(schedule);

            if ($('[data-row-schedule]').text().toLowerCase() == "advance") {
              var scheduledTime = localStorage.getItem('ecw_customer_scheduled_time');
              // console.log(scheduledTime);

              if (scheduledTime.substring(0, 2) > 12) {
                scheduledTime = (scheduledTime.substring(0, 2) - 12) + scheduledTime.substring(2) + ' PM';
              } else {
                if (scheduledTime.substring(0, 2) == 12) {
                  scheduledTime = scheduledTime + ' PM';
                } else {
                  scheduledTime = scheduledTime + ' AM';
                }
              }

              var customer_schedule = scheduledTime + ' <span style="text-transform: lowercase; ">on</span> ' + localStorage.getItem('ecw_customer_scheduled_day');

              $('[data-row-schedule]').html(customer_schedule);
              $('[data-leadtimeestimateminutes]').hide();
            }

            $("[data-order-details-header]").text(
              localStorage
                .getItem("ecw_customer_deliverymode") + " Details"
            );
            if (localStorage.getItem("ecw_customer_deliverymode") == "dispatch") {
              $("[data-order-details-header]").text("Delivery Details");
            }
            if ($("[data-row-schedule]").text() == "ADVANCE") {
              var scheduledTime = localStorage.getItem(
                "ecw_customer_scheduled_time"
              );
              if (scheduledTime.substring(0, 2) > 12) {
                scheduledTime =
                  scheduledTime.substring(0, 2) -
                  12 +
                  scheduledTime.substring(2) +
                  " PM";
              } else {
                scheduledTime = scheduledTime + " AM";
              }
              $("[data-row-schedule]").text("Today at " + scheduledTime);
              $("[data-leadtimeestimateminutes]").hide();
            }

            // Show/Hid delivery specific fields
            if (
              localStorage.getItem("ecw_customer_deliverymode") ==
              "dispatch"
            ) {
              $(
                "[data-row-deliery-to], [data-delivery-instructions]"
              ).removeClass("hide");
              // Add Delivery Info
              $("[data-delivery-address]").text(
                localStorage.getItem(
                  "ecw_customer_address_streetaddress"
                )
              );
              $("[data-delivery-city]").text(
                localStorage.getItem("ecw_customer_address_city")
              );
              $("[data-delivery-state-zip]").text(
                localStorage.getItem("ecw_customer_address_zipcode")
              );
              $("[data-row-curbside]").addClass(
                "hide"
              );
            } else if (localStorage.getItem("ecw_customer_deliverymode") ==
              "curbside") {
              $("[data-pickup-car]").text(localStorage.getItem("ecw_customer_car_color") + " " + " " + localStorage.getItem("ecw_customer_car_model") + ", " + localStorage.getItem("ecw_customer_car_make"));
              $("[data-row-deliery-to], [data-delivery-instructions], [data-delivery-location]").addClass(
                "hide"
              );
            } else {
              $("[data-row-deliery-to], [data-delivery-instructions], [data-delivery-location], [data-row-curbside]").addClass(
                "hide"
              );
            }

            // // Change store location form action
            // $("#change-store-location").click(function () {
            //   change_view("start-order");
            // });
            //
            // // Change order type
            // $("#change-order-type").click(function () {
            //   change_view("start-order");
            // });

            // get/set user contact info
            // ajax: olo_get_user_details

            // If we have user details, show that, otherwise show guest contact
            if (user_details_json && user_contact_details_json) {
              var user_details = JSON.parse(user_details_json[0]);
              var user_contact_details = JSON.parse(
                user_contact_details_json[0]
              );
              $("[data-customer-name]").text(
                user_details.firstname + " " + user_details.lastname
              );
              localStorage.setItem('ecw_customer_guest_first_name', user_details.firstname);
              localStorage.setItem('ecw_customer_guest_last_name', user_details.lastname);
              localStorage.setItem('ecw_customer_signed_in', 'yes');

              $("[data-customer-email]").text(user_details.emailaddress);
              $("[data-customer-phone]").text(
                user_contact_details.contactdetails
              );
              localStorage.setItem('ecw_customer_guest_email', user_details.emailaddress);
              localStorage.setItem('ecw_customer_guest_phone_number', user_contact_details.contactdetails);
            } else {

              $("[data-customer-name]").text(
                localStorage.getItem("ecw_customer_guest_first_name") +
                " " +
                localStorage.getItem("ecw_customer_guest_last_name")
              );
              $("[data-customer-email]").text(
                localStorage.getItem("ecw_customer_guest_email")
              );
              $("[data-customer-phone]").text(
                localStorage.getItem("ecw_customer_guest_phone_number")
              );
            }

            // get/set cart data is handled by updateBasketDisplay()
            // Show saved Billing Accounts
            if (user_billing_accounts_json) {
              if ($("#saved-cards-on-file").data("zfPlugin")) {
                $("#saved-cards-on-file").foundation("_destroy");
              }
              new Foundation.Accordion($("#saved-cards-on-file"));

              var user_billing_accounts = JSON.parse(
                user_billing_accounts_json[0]
              );
              // console.log("Billing Accounts", user_billing_accounts);

              // Clear Displayed Payments
              $("[data-billing-account-saved-template]:not(.hide)").remove();
              // Clear Saved Payments
              $("[data-billing-account-saved-template]:not(.hide)").remove();

              // Iterate through user billing accounts
              $.each(
                user_billing_accounts.billingaccounts,
                function (key, account) {
                  // Display as Standard saved account
                  var $activeSchemesContainer = $(
                    "[data-billing-schemes-active]"
                  );
                  var $savedSchemesContainer = $(
                    "[data-billing-accounts-saved]"
                  );
                  var $savedScheme = $(
                    "[data-billing-account-saved-template].hide"
                  ).clone();

                  // Display as default account
                  // if(account.isdefault) {
                  //   $savedSchemesContainer = $('[data-billing-schemes-active]');
                  //   $savedScheme = $('[data-billing-account-active-template].hide').clone();
                  // }
 
                  // Remove button actions if one exists
                  $savedScheme.find("[data-delete]").off("click");
                  $savedScheme.find("[data-remove]").off("click");
                  $savedScheme.find("[data-split]").off("click");
                  $savedScheme.find("[data-use]").off("click");

                  // Update the payment label
                  var paymentlabel = account.description;
                  if (
                    account.balance !== null &&
                    "balance" in account.balance
                  ) {
                    paymentlabel +=
                      "<br>Balance: $ " + formatMoney(account.balance.balance);
                  }
                  $savedScheme.find("[data-payment-label]").html(paymentlabel);

                  var cardTypes = ["Visa", "MasterCard", "Discover", "Amex"];


                  // console.log('adsgadsg', cardTypes, account, account.cardtype, cardTypes.includes(account.cardtype));

                  // Change payment card icon
                  if (cardTypes.includes(account.cardtype)) {
                    $savedScheme
                      .find(".fa-credit-card")
                      .addClass("fa-cc-" + account.cardtype.toLowerCase());
                    $savedScheme.find(".fa-credit-card").addClass("fa-brands");
                    $savedScheme
                      .find(".fa-credit-card")
                      .removeClass("fa-regular");
                    $savedScheme
                      .find(".fa-credit-card")
                      .removeClass("fa-credit-card");
                  }

                  // Set scheme element data params
                  $savedScheme.attr(
                    "id",
                    "billing-account-" + account.accountidstring
                  );
                  $savedScheme.attr(
                    "data-billing-account-id",
                    account.accountidstring
                  );
                  $savedScheme.attr("data-default", account.isdefault);
                  // Set split input data params
                  $savedScheme.find("input").attr("id", account.accountid);
                  $savedScheme
                    .find("input")
                    .attr("name", "account-x-" + account.cardsuffix);
                  $savedScheme
                    .find("input")
                    .attr("data-billing-account-id", account.accountidstring);
                  $savedScheme
                    .find("input")
                    .attr("data-billing-method", "billingaccount");
                  // Set action button data params
                  $savedScheme
                    .find("[data-delete]")
                    .attr("data-billing-account-id", account.accountidstring);
                  $savedScheme
                    .find("[data-remove]")
                    .attr("data-billing-account-id", account.accountidstring);
                  $savedScheme
                    .find("[data-split]")
                    .attr("data-billing-account-id", account.accountidstring);
                  $savedScheme
                    .find("[data-use]")
                    .attr("data-billing-account-id", account.accountidstring);
                  // Set split input accessible label
                  $savedScheme
                    .find("[data-apply-label]")
                    .text("Amount To Apply for " + account.description);
                  // Set input masking to ensure money formatted input
                  $savedScheme.find("input").inputmask({
                    alias: "numeric",
                    allowMinus: false,
                    digits: 2,
                    max: 999.99,
                  });

                  // Remove Payment action
                  $savedScheme.find("[data-remove]").click(function () {
                    console.log('remove');

                    $(this).closest('.actions').find('[data-split]').text('USE').removeClass('applied');
                    $(this).closest('.actions').find('[data-use]').text('USE').removeClass('applied');
                    $(this).closest('.active-payment').find('[data-split-input]').addClass('hide');

                    removePayment($(this).attr("data-billing-account-id"), $(this));
                  });
                  // Use Payment action
                  $savedScheme
                    .find("[data-use], [data-split]")
                    .click(function () {
                      // console.log('i click');
                      usePayment($(this).attr("data-billing-account-id"));
                      $(this).text("Applied").addClass('applied');
                    });
                  // Delete Payment action
                  $savedScheme.find("[data-delete]").click(function () {
                    ecw_show_loading();
                    var billingAccountId = $(this).attr(
                      "data-billing-account-id"
                    );
                    $.when(olo_delete_billing_account(billingAccountId)).done(
                      function (deleted_billing_json) {
                        // console.log(deleted_billing_json);
                        var result = "";
                        if (deleted_billing_json) {
                          result = JSON.parse(deleted_billing_json);
                        }
                        // $('[data-open="credit-card-reveal"]').removeClass('hide');
                        if (result && "code" in result) {
                          console.log("checkout error", result);
                          setCheckoutError(result.message);
                        } else {
                          clearCheckoutError();
                          // console.log("clear");
                          $("#billing-account-" + billingAccountId).remove();
                          configPaymentOptions();
                        }

                        ecw_hide_loading();
                      }
                    );
                  });

                  $savedScheme.removeClass("hide");
                  $savedSchemesContainer.append($savedScheme);
                }
              );

              // set default payment if present
              $("[data-billing-accounts-saved] .active-payment").each(
                function () {
                  if ($(this).attr("data-default") === "true") {
                    usePayment($(this).attr("data-billing-account-id"));
                  }
                }
              );

              configPaymentOptions();
            } // if(user_billing_accounts_json)

            var $paymentDetailsSection = $("[data-payment-details-section]");
            // Display Payment Options
            if (billing_schemes_json) {
              var billing_schemes = JSON.parse(billing_schemes_json[0]);
              // console.log('billing_schemes', billing_schemes);
              var $bs_container = $("[data-billing-schemes]");
              $bs_container
                .find("[data-billing-scheme-button]:not(.hide)")
                .remove();

              // console.log("billing schemes", billing_schemes);

              $.each(billing_schemes.billingschemes, function (key, scheme) {
                // console.log('billingschemes', scheme);

                if (scheme.type == "creditcard") {
                  var $bs_item = $bs_container
                    .find("[data-billing-scheme-button].hide")
                    .clone();

                  $bs_item
                    .find("[data-billing-scheme-name]")
                    .text("ADD debit/Credit Card");
                  $bs_item.find("." + scheme.type).removeClass("hide");
                  $bs_item.attr("data-open", "credit-card-reveal");

                  $bs_item.removeClass("hide").addClass('full-width');
                  $bs_container.append($bs_item);
                } else if (scheme.type == "payinstore" || scheme.type == "external") {
                  if (scheme.name == "Google Pay") {
                    loadInDigitalWallets(billing_schemes);
                    $('[data-olo-pay]').removeClass('hide');
                  }
                  if (scheme.name == "Apple Pay") {
                    loadInDigitalWallets(billing_schemes);
                    $('[data-olo-pay]').removeClass('hide');
                  }
                  // console.log(scheme.name, scheme.id); 

                } else {
                  var $bs_item = $bs_container
                    .find("[data-billing-scheme-button].hide")
                    .clone();
                  if (scheme.name === "East Coast Wings Gift Card") {
                    $bs_item.addClass('white-w-border');
                    $bs_item
                      .find("[data-billing-scheme-name]")
                      .text("Add ECW+G Gift Card");
                  } else {
                    $bs_item
                      .find("[data-billing-scheme-name]")
                      .text(scheme.name);
                  }

                  $bs_item.find("." + scheme.type).removeClass("hide");
                  var $paymentModalContainer = $("[data-payment-modals]");
                  var $paymentRevealTemplate = $paymentModalContainer
                    .find("[data-payment-reveal-scheme-template].hide")
                    .clone();
                  var $schemeForm = $(
                    '<form id="scheme_' + scheme.id + '" novalidate></form>'
                  );

                  $paymentRevealTemplate
                    .find("[data-payment-scheme]")
                    .text(scheme.name);
                  $paymentRevealTemplate.attr("id", "payment_" + scheme.id);
                  $paymentRevealTemplate.removeAttr(
                    "data-payment-reveal-scheme-template"
                  );
                  $bs_item.attr("data-open", "payment_" + scheme.id);

                  $.each(scheme.fields, function (key, field) {
                    // Create a unique ID for the input
                    var inputId = "scheme_" + scheme.id + "_" + field.name;

                    // Create input field with label
                    var $inputField = $('<label>')
                      .text(field.label)
                      .append(
                        $('<input>')
                          .attr({
                            type: field.type,
                            name: field.name,
                            id: inputId,
                            maxlength: field.maxlength,
                            minlength: field.minlength,
                            required: field.isMandatory || false,
                            'aria-describedby': inputId + '-error'
                          })
                      )
                      // Add a span for the error message
                      .append(
                        $('<span>')
                          .attr({
                            id: inputId + '-error',
                            class: 'form-error'
                          })
                          .text(field.isMandatory ? 'This field is required.' : 'Please enter a valid value.')
                          .hide() // hidden by default
                      );

                    $schemeForm.append($inputField);
                  });

                  $schemeForm.append(
                    '<input type="hidden" name="schemeName" value="' +
                    scheme.name +
                    '">'
                  );
                  $schemeForm.append(
                    '<input type="hidden" name="schemeID" value="' +
                    scheme.id +
                    '">'
                  );
                  $schemeForm.append(
                    '<input type="hidden" name="schemeType" value="' +
                    scheme.type +
                    '">'
                  );

                  $schemeForm.append(
                    $(
                      '<div class="small-12 cell save-card"><label><input name="saveonfile" type="checkbox" value=""> Save card to account?</label></div>'
                    )
                  );

                  $schemeForm.append(
                    $(
                      '<div class=""><div class="small-6 cell text-right"><button name="addCard" class="button">Add Card</button></div></div>'
                    )
                  );

                  $paymentRevealTemplate.find('.cont').append($schemeForm);
                  $paymentRevealTemplate.removeClass("hide");

                  $paymentModalContainer.append($paymentRevealTemplate);

                  // console.log("create reveal:", "payment_" + scheme.id);

                  var paymentReveal = new Foundation.Reveal(
                    $paymentRevealTemplate,
                    {}
                  );

                  var paymentAbide = new Foundation.Abide(
                    $("#scheme_" + scheme.id),
                    {}
                  );

                  // Form Actions
                  $("#scheme_" + scheme.id).submit(function (e) {
                    e.preventDefault();
                  });

                  // Show error messages for invalid fields
                  $("#scheme_" + scheme.id).on('invalid.zf.abide', function (ev, frm) {
                    console.log('no valid', frm);
                    var errorId = frm.attr('aria-describedby');
                    if (errorId) {
                      $('#' + errorId).show(); // Show the associated error message
                    }
                  });
                  $("#scheme_" + scheme.id).on('valid.zf.abide', function (ev, frm) {
                    console.log('now valid');

                    $(frm).find('.form-error').hide();
                    var errorId = frm.attr('aria-describedby');
                    if (errorId) {
                      $('#' + errorId).hide(); // Show the associated error message
                    }
                  });
                  // On Form Validation
                  $("#scheme_" + scheme.id).on(
                    "formvalid.zf.abide",
                    function () {
                      var schemeName = $(this)
                        .find('input[name="schemeName"]')
                        .val();
                      var cardNumber = $(this)
                        .find('input[name="number"]')
                        .val();
                      var cardPin = $(this).find('input[name="pin"]').val();
                      var schemeType = $(this)
                        .find('input[name="schemeType"]')
                        .val();
                      var schemeID = $(this)
                        .find('input[name="schemeID"]')
                        .val();
                      var saveOnFile = $(this)
                        .find('input[name="saveonfile"]')
                        .prop("checked");

                      ecw_show_loading();

                      $("#payment_" + schemeID)
                        .find(".card-error")
                        .addClass("hide");
                      $("#payment_" + schemeID)
                        .find(".card-error [data-error-message]")
                        .attr('aria-describedby', 'scheme_' + schemeID + '_error').removeAttr('aria-live');

                      $.when(
                        olo_get_gift_card_balance(schemeID, cardNumber, cardPin)
                      ).done(function (cardBalance_json) {

                        var cardBalance = JSON.parse(cardBalance_json);
                        // console.log('olo_get_gift_card_balance', cardBalance);

                        if (cardBalance.success) {
                          var $savedSchemesContainer = $(
                            "[ data-billing-schemes-active]"
                          );
                          var $savedScheme = $(
                            "[data-billing-schemes-active-template].hide"
                          ).clone();

                          $savedScheme.attr(
                            "id",
                            "new-" + schemeType + "-" + cardNumber
                          );
                          $savedScheme
                            .find("[data-payment-label]")
                            .html(
                              "New " +
                              schemeName +
                              "<br>Balance: $ " +
                              formatMoney(cardBalance.balance)
                            );

                          $savedScheme.find("[data-edit]").parent().remove();

                          $savedScheme
                            .find("input")
                            .attr("id", "gift-card-" + cardNumber);
                          $savedScheme
                            .find("input")
                            .attr("name", "account-x-" + schemeType);

                          $savedScheme
                            .find("input")
                            .attr("data-gift-card-num", cardNumber);
                          $savedScheme
                            .find("input")
                            .attr("data-gift-card-pin", cardPin);
                          $savedScheme
                            .find("input")
                            .attr("data-save-on-file", saveOnFile);

                          $savedScheme
                            .find("input")
                            .attr("data-scheme-type", schemeType);
                          $savedScheme
                            .find("input")
                            .attr("data-scheme-id", schemeID);

                          $savedScheme.removeClass("hide");
                          $savedSchemesContainer.append($savedScheme);

                          $savedScheme.find("[data-remove]").click(function () {
                            // console.log('remove');
                            // console.log("remove card");
                            // Remove payment
                            $(this).closest('.actions').find('[data-use]').text('USE').removeClass('applied');
                            $(this).closest('.actions').find('[data-split]').text('USE').removeClass('applied');

                            $(this).parents(".active-payment").remove();
                            configPaymentOptions();
                          });

                          configPaymentOptions();

                          // Close modal and clear inputs
                          $("#payment_" + schemeID).foundation("close");
                          $("#payment_" + schemeID)
                            .find('input:not([type="hidden"])')
                            .each(function () {
                              $(this).val("");
                            });
                        } else {
                          console.log('cardBalance', cardBalance);
                          $("#payment_" + schemeID)
                            .find(".card-error [data-error-message]")
                            .text(cardBalance.message);
                          $("#payment_" + schemeID)
                            .find(".card-error")
                            .removeClass("hide");
                        }

                        ecw_hide_loading();
                      });
                    }
                  );
                  $bs_item.addClass("transparent-button");
                  $bs_item.removeClass("hide");
                  $bs_container.append($bs_item);
                }


              });

              configPaymentOptions();
            } // if(billing_schemes_json)


            // Coupon Code Actions
            $("[data-add-coupon-code]").off("click");
            $("[data-add-coupon-code]").on("click", function () {
              // Only process if field is not empty
              if ($("#checkout-coupon-code").val()) {
                ecw_show_loading();
                $.ajax({
                  type: "POST",
                  url: ajax_url,
                  data: {
                    action: "olo_apply_coupon_to_basket",
                    basketGuid: localStorage.getItem(
                      "ecw_customer_basket_id"
                    ),
                    couponcode: $("#checkout-coupon-code").val(),
                    referer: window.location.href

                  },
                  success: function (response) {
                    // console.log(response);
                    var result = JSON.parse(response);

                   const $couponInput = $("input#checkout-coupon-code");
                    const $couponError = $(".coupon-error");

                    if ("code" in result) {
                      // Error returned
                      $couponError
                        .find("[data-error-message]")
                        .text(result.message);

                      $couponError.removeClass("hide");

                      $couponInput
                        .attr("aria-invalid", "true")
                        .attr("aria-describedby", "coupon-error-message")
                        .focus();

                    } else {
                      // Coupon successful
                      $couponError
                        .addClass("hide")
                        .find("[data-error-message]")
                        .text(""); 

                      $couponInput
                        .removeAttr("aria-invalid")
                        .removeAttr("aria-describedby");

                      updateBasketDisplay();
                    }
                  },
                  complete: function () {
                    ecw_hide_loading();
                  },
                });
              }
            });

            // Cart Submission action Action ACTION
            $("#cart-checkout-place-order").off("click");
            $("#cart-checkout-place-order").on("click", function () {
              ecw_show_loading();
              clearCheckoutError();

              // console.log("checkout clicked");

              var billingAccounts = [];

              var tipTotal = Number($('#custom-tip-amount').val());
              var paymentSplits = $("[data-billing-schemes-active] .active-payment:not(.hide) input").length;

              // if one or more payment methods are being charged less than the tip split, don't include them in the split calculation
              var paymentsLessThanTipSplit = 0;
              $('[data-billing-schemes-active] .active-payment:not(.hide) input').each(function (index, value) {
                var amount = Number($(this).val());
                if (amount < Math.ceil((tipTotal / paymentSplits) * 100) / 100) {
                  paymentsLessThanTipSplit++;
                }
              });

              if (paymentsLessThanTipSplit > 0) {
                paymentSplits = paymentSplits - paymentsLessThanTipSplit;
              }

              var tipSplit = Math.floor((tipTotal / paymentSplits) * 100) / 100;
              var tipSplitFinal = tipSplit;

              if ((tipSplit * paymentSplits) !== tipTotal) {
                tipSplitFinal = Math.ceil((tipTotal / paymentSplits) * 100) / 100;
              }

              $("[data-billing-schemes-active] .active-payment:not(.hide) input").each(function (index, value) {
                var isLastElement = index == paymentSplits - 1;

                var paymentTipSplit = tipSplit;
                if (isLastElement) {
                  paymentTipSplit = tipSplitFinal;
                }
                // console.log('#1');
                if ($(this).attr("name") == "account-x-new-card") {
                  // add new CC
                  var billing_amount = Number($(this).val());

                  var expirationDate = $("#expiredate").val().split("/");
                  var postalCode = $("#postalCode").val();

                  var tipPortion = paymentTipSplit;
                  if (billing_amount < tipPortion) {
                    tipPortion = 0;
                  }

                  var billingMethod = $(this).attr("data-billing-method");

                  // console.log('billingMethod', billingMethod);
                  billingAccounts.push({
                    amount: billing_amount,
                    billingMethod: "creditcard",
                    expiryMonth: expirationDate[0],
                    expiryYear: "20" + expirationDate[1],
                    zip: postalCode,
                    tipPortion: tipPortion,

                    // streetAddress: "26 Broadway",
                    // streetAddress2: "",
                    // city: "New York",
                    // state: "NY",
                    // zip: "10004"

                    saveOnFile: $("#cc_saveonfile").prop("checked"), // For Saving Billing Info
                  });
                } else if ($(this).attr("name") == "account-x-giftcard") {
                  var billing_amount = Number($(this).val());
                  var card_number = $(this).attr("data-gift-card-num");
                  var card_pin = $(this).attr("data-gift-card-pin");
                  var card_scheme_id = $(this).attr("data-scheme-id");
                  var saveOnFile = $(this).attr("data-save-on-file") == "true";

                  // console.log($(this).attr("data-save-on-file"), saveOnFile);

                  var tipPortion = paymentTipSplit;
                  if (billing_amount < tipPortion) {
                    tipPortion = 0;
                  }


                  billingAccounts.push({
                    amount: billing_amount,
                    billingFields: [
                      {
                        name: "number",
                        value: card_number,
                      },
                      {
                        name: "pin",
                        value: card_pin,
                      },
                    ],
                    billingMethod: "storedvalue",
                    billingSchemeId: card_scheme_id,
                    tipPortion: tipPortion,
                    saveOnFile: saveOnFile,
                  });
                } else {
                  // Add Billing Account if present
                  var billing_amount = Number($(this).val());
                  var billing_account_id = $(this).attr("data-billing-account-id");
                  var billingMethod = $(this).attr("data-billing-method"); // "cash", "creditcard", "storedvalue", "billingaccount", "creditcardonfile"

                  var tipPortion = paymentTipSplit;
                  if (billing_amount < tipPortion) {
                    tipPortion = 0;
                  }

                  billingAccounts.push({
                    amount: billing_amount,
                    billingMethod: billingMethod,
                    billingAccountId: billing_account_id,
                    tipPortion: tipPortion
                  });
                }
              });
              if (localStorage.getItem("ecw_customer_membership_id") && localStorage.getItem("ecw_auth_token")) {
                var submissionPacket = {
                  id: localStorage.getItem("ecw_customer_basket_id"),
                  accessToken: localStorage.getItem("ecw_customer_ccsf_token"),
                  userType: "user",
                  authtoken: localStorage.getItem("ecw_auth_token"),

                  firstName: localStorage.getItem("ecw_customer_guest_first_name"),
                  lastName: localStorage.getItem("ecw_customer_guest_last_name"),
                  emailAddress: localStorage.getItem("ecw_customer_guest_email"),
                  contactNumber: localStorage.getItem("ecw_customer_guest_phone_number"),
                  guestOptIn: false,
                  billingAccounts: billingAccounts,
                };
              } else {
                var submissionPacket = {
                  id: localStorage.getItem("ecw_customer_basket_id"),
                  accessToken: localStorage.getItem("ecw_customer_ccsf_token"),
                  firstName: localStorage.getItem("ecw_customer_guest_first_name"),
                  lastName: localStorage.getItem("ecw_customer_guest_last_name"),
                  emailAddress: localStorage.getItem("ecw_customer_guest_email"),
                  contactNumber: localStorage.getItem("ecw_customer_guest_phone_number"),
                  // userType: "guest",
                  guestOptIn: false,
                  billingAccounts: billingAccounts,
                };
              }


              // console.log('submissionPacket', submissionPacket);

              $.when(
                olo_set_delivery_instructions(),
                olo_set_custom_fields(),
                olo_validate_basket()
              ).done(function (delivery_inst, custom_fields, validate_return) {
                // console.log('validate_return', validate_return);
                checkoutFrame.submit(submissionPacket);
                console.log('submissionPacket', submissionPacket);
                checkoutFrame.on("success", function (order) {
                  console.log(order.id, order);

                  // Get Order
                  // console.log('olo_get_order');

                  $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: {
                      action: "olo_get_order",
                      orderguid: order.id,
                      referer: window.location.href

                    },
                    success: function (response) {
                      var order_data = JSON.parse(response);

                      // Send GA4/GTM Ecomm Data
                      var gtmDLProducts = [];
                      var ga4DLProducts = [];

                      // Set Analytics product data
                      for (var i = 0; i < order_data.products.length; i++) {
                        gtmDLProducts.push({
                          "name": order_data.products[i].name,
                          "sku": order_data.products[i].id,
                          "price": order_data.products[i].totalcost,
                          "quantity": order_data.products[i].quantity,
                          // 'category': result.products[i]
                        });
                        ga4DLProducts.push({
                          "item_id": order_data.products[i].id,
                          "item_name": order_data.products[i].name,
                          "price": order_data.products[i].totalcost,
                          "quantity": order_data.products[i].quantity,
                          "affiliation": order.vendorname
                          // "item_category": localStorage.getItem('lumos_orderstate')
                        });
                      }

                      // Set User Type
                      var orderUserType = "Guest";
                      if (localStorage.getItem("ecw_auth_token")) {
                        orderUserType = "Member";
                      }

                      // Set Taxes
                      var orderTaxes = 0;
                      for (var ii = 0; order_data.taxes.length > ii; ii++) {
                        orderTaxes += order_data.taxes[ii].tax;
                      }

                      // Set Order Fees
                      var orderFees = 0;
                      for (var iii = 0; order_data.fees.length > iii; iii++) {
                        orderFees += order_data.fees[iii].amount;
                      }
                      if (order_data.customerhandoffcharge) {
                        orderFees += order_data.customerhandoffcharge;
                      }

                      // Set Order Coupon
                      var orderCoupon = "";
                      for (var iv = 0; order_data.discounts.length > iv; iv++) {
                        if (order_data.discounts[iv].type == "Coupon") {
                          orderCoupon = order_data.discounts[iv].description;
                          break;
                        }
                      }

                      var gtmDL = {
                        "event": "purchase", // Residential - eCommerce - Order Captured
                        "transactionId": order_data.oloid,
                        "transactionTotal": order_data.total,
                        "transactionTax": orderTaxes,
                        "transactionProducts": gtmDLProducts,
                        "shipping": orderFees,
                        "transactionShipping": orderFees,
                        "affiliation": order_data.vendorname,
                        "transactionAffiliation": order_data.vendorname,
                        "coupon": orderCoupon,
                        "userType": orderUserType,
                        "orderType": order_data.deliverymode,
                      };

                      var ga4CustomerEmail = localStorage.getItem("ecw_customer_guest_email");
                      var ga4PhoneNumber = localStorage.getItem("ecw_customer_guest_phone_number");
                      var ga4UserID = localStorage.getItem("ecw_user_id");

                      if (user_details_json && user_contact_details_json) {
                        var user_details = JSON.parse(user_details_json[0]);
                        var user_contact_details = JSON.parse(user_contact_details_json[0]);

                        ga4CustomerEmail = user_details.emailaddress;
                        ga4PhoneNumber = user_contact_details.contactdetails;
                      }

                      var ga4DL = {
                        "event": "purchase",
                        'ecommerce': {
                          "transaction_id": order.oloid,
                          "affiliation": order.vendorname,
                          "value": order.total,
                          "tax": orderTaxes,
                          "currency": "USD",
                          "coupon": orderCoupon,
                          "userType": orderUserType,
                          "orderType": order.deliverymode,
                          "shipping": orderFees,
                          "items": ga4DLProducts
                        },
                        "user_data": {
                          "user_id": ga4UserID,
                          "email_address": ga4CustomerEmail,
                          "phone_number": ga4PhoneNumber
                        }
                      };

                      // console.log("GTMDL: ", gtmDL);
                      // console.log('GA4DL:', ga4DL);
                      const hasExtraCookieConsent = checkNonNecessaryConsent();
                      if (hasExtraCookieConsent) {
                        // Push Legacy DataLayer GTM
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(ga4DL);
                      }



                      // var ga4Data = {
                      //   'event': "purchase",
                      //   'ecommerce': ga4DL
                      // };
                      // console.log('GA4:', ga4Data);

                      // Push into GA4
                      // gtag('event', 'purchase', ga4DL);

                      // window.dataLayer.push({ ecommerce: null });
                      // window.dataLayer.push(ga4Data);

                      // Clear cart session
                      clearBasketSession();
                      localStorage.setItem(
                        "ecw_customer_order",
                        JSON.stringify(order)
                      );
                      //
                      // change_view("order-complete");
                      // console.log('results', order); 
                      view_order_complete(order);
                      history.pushState(null, '', '/order/#order-complete');

                    },
                  });
                });

                checkoutFrame.on("error", function (errors) {
                  console.log('errors', errors);
                  errors.forEach((error) => {
                    console.log("checkout error", errors);

                    console.log('error', error);
                    if (error instanceof DOMException && error.name === 'SecurityError') {
                      alert(
    "Something went wrong. Please try again.\n\n" +
    "This may be related to your selected payment method. Please try a different payment method.\n\n" +
    "Error: " + error.description
);
                    }  

                    // console.log(error.code, error.description);
                    setCheckoutError(error.description);
                    ecw_hide_loading();
                  });
                });
              });
            });

            // update basket
            // console.log('update basket test #1');
            updateBasketDisplay();
            $(".wf-ordering-checkout").removeClass("hide");
            ecw_hide_loading();
          });
        });
      }).hide().fadeIn(transitionDuration);
    });
  } else {
    ecw_hide_loading();
    change_view("menu");
  }
}

function olo_set_tip_amount(amount) {
  var $ = jQuery;

  // console.log('set tip: ', amount);

  if (localStorage.getItem('ecw_customer_basket_id')) {

    // console.log(localStorage.getItem('ecw_customer_basket_id'), amount);

    ecw_show_loading();

    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'olo_set_tip_amount',
        basketGuid: localStorage.getItem('ecw_customer_basket_id'),
        amount: amount,
        referer: window.location.href,
      },
      success: function (response) {
        // console.log(response);
        var result = JSON.parse(response);
        if ('code' in result) {
          // console.log("checkout error", result);

          setCheckoutError(result.message);
          ecw_hide_loading();
        } else {
          // console.log('update basket test #2');
          clearCheckoutError();
          updateBasketDisplay();
        }

      },
      complete: function () {

      }
    });
  }
}
